import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'
import { getEmpresas, getTps } from '../../../localstorage/localstorage.service'
import { urlRegisterClient2 } from '../../routes/registration.routes'

export async function sendEmailRetrievePassword(email) {
  try {
    const url = routes.urlPostSendRetriePasswordEmail(email)
    const response = await authHttp().post(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function changePassword(token, password) {
  try {
    const url = routes.urlPostChangePassword(token)
    const response = await authHttp().post(url, { password })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function registerClient(
  {
    nomeFantasia,
    razaoSocial,
    cnpj,
    city_id,
    address,
    district,
    number,
    makeParcialReturn,
    actived,
    latitude,
    longitude,
    observation,
    phone,
    cep,
    inscricao_estadual,
  },
  tp_id,
) {
  try {
    const response = await authHttp().post(routes.urlRegisterClient(tp_id), {
      nomeFantasia,
      razaoSocial,
      cnpj,
      city_id,
      address,
      district,
      number,
      makeParcialReturn,
      actived,
      latitude,
      longitude,
      observation,
      phone,
      cep,
      inscricao_estadual,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function registerClient2(cliente, company_id) {
  try {
    const url = urlRegisterClient2()
    const response = await authHttp().post(url, { cliente, company_id })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function registerClientAndAssociateCompany(client, company_code, cycle_id, tp_id) {
  try {
    const response = await authHttp().post(
      routes.urlRegisterClientAndAssocCompany(tp_id, cycle_id),
      { client, company_code },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateClient(cliente) {
  try {
    const response = await authHttp().put(routes.urlUpdateClient(cliente.id), cliente)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClients(tp_id) {
  try {
    const tpIds = getTps()
      .map(t => t.id)
      .join(',')
    const response = await authHttp().get(routes.urlGetClients(tp_id, tpIds))

    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientsByFleetId(fleetId) {
  try {
    const response = await authHttp().get(routes.urlGetClientsByFleetId(fleetId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function clientTpAssociatonHandler(client_id, tp_id, actived) {
  try {
    const allowedTps = getTps().map(t => t.id)
    const response = await authHttp().post(routes.urlPostClientTpAssociation, {
      client_id,
      tp_id,
      actived,
      allowedTps,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientTpsAssociaton(client_id) {
  try {
    const tpIds = getTps()
      .map(tp => tp.id)
      .join(',')
    const response = await authHttp().get(routes.urlGetClientTpAssociation(client_id, tpIds))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function clientCompanyAssociatonHandler(client_id, company_id, company_code, actived) {
  try {
    const allowedCompanies = getEmpresas().map(t => t.id)
    const response = await authHttp().post(routes.urlPostClientCompanyAssociation, {
      client_id,
      company_id,
      actived,
      company_code,
      allowedCompanies,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientCompaniesAssociaton(client_id) {
  try {
    const companiesIds = getEmpresas()
      .map(tp => tp.id)
      .join(',')
    const response = await authHttp().get(
      routes.urlGetClientCompanyAssociation(client_id, companiesIds),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTrechos(client_id, centraloperacoes_id) {
  try {
    const response = await authHttp().get(routes.urlGetTrechos(client_id, centraloperacoes_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTrechos({ client_id, tp_id, centraloperacoes_id }) {
  try {
    const response = await authHttp().post(routes.urlPostTrecho, {
      client_id,
      tp_id,
      operationcenter_id: centraloperacoes_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteTrechos(trecho_id, centraloperacoes_id) {
  try {
    const response = await authHttp().delete(routes.urlDeleteTrecho(trecho_id, centraloperacoes_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveClientesSemTrecho(associacoes) {
  try {
    const response = await authHttp().post(routes.urlPostClientesSemTrecho, associacoes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getAssocRotaEntregaCliente(cliente_id, tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetAssocRotaEntregaCliente(tp_id, cliente_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveAssocRotaEntregaCliente(rota_id, cliente_id, tp_id) {
  try {
    const response = await authHttp().post(routes.urlPostAssocRotaEntregaCliente(), {
      rota_id,
      cliente_id,
      tp_id,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function searchClientsByCnpjOrName(term, tpId) {
  try {
    const response = await authHttp().get(routes.urlSearchClientsByCnpjOrName(term, tpId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientByDeliveryId(deliveryId) {
  try {
    const response = await authHttp().get(routes.urlGetClientByDeliveryId(deliveryId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
